export default {
  settings: {
    revokeOrder: "撤销订单",
    cancelList: "取消列表",
  },
  revoke: {
    listTitle: "撤销订单列表",
    storeInfo: "商户信息",
    orderAmount: "订单金额",
    orderTotal: "订单总额",
    orderSource: "订单来源",
    contactPhone: "联系电话",
    riderInfo: "骑手信息",
    cancelling: "取消中",
    cancelled: "已取消",
    rejected: "拒绝",
    cancelOrder: "取消订单",
    rejectOrder: "拒绝订单",
  },
  cancelReason: {
    listTitle: "取消订单列表",
    add: "新增",
    reason: "取消原因",
    addTime: "添加时间",
  },
  detail: {
    title: "订单详情",
    orderNo: "订单号",
    orderDistance: "订单距离",
    deliveryInfo: "配送信息",
    storeName: "商家名称",
    pushTime: "推单时间",
    orderType: "订单类型",
    takeaway: "外卖订单",
    actualAmount: "实付金额",
    orderItems: "订单明细",
    orderCode: "订单编号",
    seqPrefix: "序号",
    orderChannel: "订单渠道",
    orderNote: "订单备注",
    goodsAmount: "商品实付金额",
    goodsDetail: "商品详情",
    none: "无",
    pickCode: "取件码",
    pickPhoto: "取件照片",
    receiveCode: "收货码",
    receivePhoto: "收货照片",
    locationInfo: "位置信息",
    riderInfo: "配送员信息",
    riderName: "骑手姓名",
    riderTel: "骑手电话",
    expectedIncome: "预计收入",
    operationLog: "订单操作记录",
    content: "内容",
    operateTime: "操作时间",
  },
};
